import { Options, Vue } from 'vue-class-component';

import List from '@/pages/config/system-access-profile/list/list.vue';

@Options({
  name: 'system-access-profile',
  components: {
    'page-list': List,
  },
})
export default class SystemAccessProfile extends Vue {
  public isIndexOnly() {
    return /^[/]?system-access-profile[/]?$/.test(this.$router.currentRoute.value.path);
  }
}
